/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Sc_PrefsInputs */

const en_pc_tut_sc_prefs = /** @type {(inputs: Pc_Tut_Sc_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferences`)
};

const zh_pc_tut_sc_prefs = /** @type {(inputs: Pc_Tut_Sc_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`偏好设置`)
};

/**
* | output |
* | --- |
* | "Preferences" |
*
* @param {Pc_Tut_Sc_PrefsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_sc_prefs = /** @type {((inputs?: Pc_Tut_Sc_PrefsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Sc_PrefsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_sc_prefs(inputs)
	return zh_pc_tut_sc_prefs(inputs)
});
export { pc_tut_sc_prefs as "pc.tut.sc.prefs" }